import {FileMimeType} from '@/libs/mimeTypes'

export function convertFloat(val, decimalPlaces = 2) {
    if (val) return val.toLocaleString(undefined, {minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces})
    return '0.00'
}


export async function downloadAttachment(thisIns, requestUrl, filename, checkDocumentType = false)  {
    try {
        let fileType = 'pdf'

        const response = await thisIns.$http.get(requestUrl, {responseType: 'blob'})
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url

        if (checkDocumentType) {
            fileType = FileMimeType[response.data.type]
            link.setAttribute('download', `${filename}.${fileType}`)
        } else link.setAttribute('download', filename)

        document.body.appendChild(link)
        link.click()
    } catch (error) {
        thisIns.$printError('Ni dokumenta/ov za prenos')
    }
}